import { ICreateOrderInitialState } from "./types";

const initialState: ICreateOrderInitialState = {
  readOnlyTakeOff: true,
};

export default initialState;